import { render } from "./TourUploadBox.vue?vue&type=template&id=2afbc25a"
import script from "./TourUploadBox.vue?vue&type=script&lang=js"
export * from "./TourUploadBox.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2afbc25a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2afbc25a', script)) {
    api.reload('2afbc25a', script)
  }
  
  module.hot.accept("./TourUploadBox.vue?vue&type=template&id=2afbc25a", () => {
    api.rerender('2afbc25a', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/TourUploadBox.vue"

export default script